export const defaultMemberEmailCheckerFormAssets = {
    submitButtonIconName: 'chevron-right'
};
//# sourceMappingURL=assets.js.map